import React from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { toDisplayFormat } from 'src/utils/Completion';
import { getOptionLabel } from 'src/utils/Utils';
import { getSelectOptions } from 'src/reducers/selectOptions';
import styles from './PayrollRuleInfo.scss';

const PayrollRuleInfo = ({ payrollRule, payrollTypes }) => {
  const { t } = useTranslation();
  const isSemiMonthly = payrollRule?.paymentCount === 'twice';

  return (
    <div>
      {payrollRule && (
        <div className="u-mb20">
          <table className={styles.table}>
            <tbody>
              <tr>
                <th>
                  {!isSemiMonthly
                    ? t('features.Employees.components.PayrollRulenInfo.cutoff_date')
                    : t('features.Employees.components.PayrollRulenInfo.first_half_cutoff_date')}
                </th>
                <td>{payrollRule.closingLabel}</td>
              </tr>
              <tr>
                <th>
                  {!isSemiMonthly
                    ? t('features.EmployeeAttendances.EmployeeAttendanceDownloadCsvPage.payment_date')
                    : t('features.Employees.components.PayrollRulenInfo.first_half_payment_date')}
                </th>
                <td>{payrollRule.paymentLabel}</td>
              </tr>
              {isSemiMonthly && (
                <>
                  <tr>
                    <th>{t('features.Employees.components.PayrollRulenInfo.second_half_cutoff_date')}</th>
                    <td>{payrollRule.closingLabelSecondHalf}</td>
                  </tr>
                  <tr>
                    <th>{t('features.Employees.components.PayrollRulenInfo.second_half_payment_date')}</th>
                    <td>{`${payrollRule.paymentLabelSecondHalf}`}</td>
                  </tr>
                </>
              )}
              <tr>
                <th>{t('features.Employees.components.PayrollRulenInfo.form_of_salary')}</th>
                <td>{getOptionLabel(payrollRule.payrollType)(payrollTypes)}</td>
              </tr>
              <tr>
                <th>{t('features.Employees.components.PayrollRulenInfo.designated_working_hours_in_one_day')}</th>
                <td>{payrollRule.prescribedWorkingHoursPerDay}</td>
              </tr>
              <tr>
                <th>{t('features.Employees.components.PayrollRulenInfo.average_designated_working_days_in_one_month')}</th>
                <td>{toDisplayFormat(payrollRule.avgRegularWorkingDaysPerMonth)}</td>
              </tr>
              <tr>
                <th>{t('features.Employees.components.PayrollRulenInfo.average_designated_working_hours_in_one_month')}</th>
                <td>{payrollRule.avgRegularWorkingHoursPerMonth}</td>
              </tr>
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

const mapStateToProps = state => ({
  payrollTypes: getSelectOptions(state, 'payrollTypes')
});

export default connect(mapStateToProps)(PayrollRuleInfo);
